// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".220264fdd36fa4da2dad1cc29eb69d9e.js";
};